/* global dataLayer */

export function triggerGtmEvent(eventObj) {
  window.dataLayer.push(eventObj);
}



// WEBPACK FOOTER //
// ./src/util/gtm.js